import { render, staticRenderFns } from "./ImageUploadItem.vue?vue&type=template&id=8bddb112&scoped=true&"
import script from "./ImageUploadItem.vue?vue&type=script&lang=tsx&"
export * from "./ImageUploadItem.vue?vue&type=script&lang=tsx&"
import style0 from "./ImageUploadItem.vue?vue&type=style&index=0&id=8bddb112&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bddb112",
  null
  
)

export default component.exports